import { getRegexes } from '../../api/regex'
import useApiCall from '../../api/useApiCall'
import { useLookupStore } from '../../stores/lookUpStore'
import LoadingSection from '../LoadingSection/LoadingSection'
import NLUDataHeader from '../NLUData/NLUDataHeader/NLUDataHeader'

import RegexTable from './RegexTable/RegexTable'

import styles from './lookup.module.scss'

function Lookup() {
    const [, { setRegexes }] = useLookupStore()

    const [{ loading }] = useApiCall(getRegexes, setRegexes)

    return (
        <main className={styles.lookup}>
            <NLUDataHeader />
            <section className={styles.lookup__section}>
                {loading ? <LoadingSection /> : <RegexTable />}
            </section>
        </main>
    )
}

export default Lookup
